import { useAuth0 } from '@auth0/auth0-react';
import { Box, Button, Container } from '@mui/material';
import { useSearchParams } from 'react-router';

export const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { loginWithRedirect } = useAuth0();
  const to = searchParams.get('to');

  return (
    <Container
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box display="flex" gap="36px" justifyContent="center" flexDirection="column">
        <Button
          style={{ width: '240px' }}
          size="large"
          variant="contained"
          onClick={() => loginWithRedirect({ appState: { returnTo: to ?? '/' } })}
        >
          Sign in
        </Button>
      </Box>
    </Container>
  );
};
